import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 21h1a1 1 0 0 0 1 -1v-1a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2","key":"svg-0"}],["path",{"d":"M7 7v.01","key":"svg-1"}],["path",{"d":"M7 10v.01","key":"svg-2"}],["path",{"d":"M7 13v.01","key":"svg-3"}],["path",{"d":"M17 7v.01","key":"svg-4"}],["path",{"d":"M17 10v.01","key":"svg-5"}],["path",{"d":"M17 13v.01","key":"svg-6"}]]

const IconBuildingFortress = createReactComponent('outline', 'building-fortress', 'BuildingFortress', __iconNode);

export default IconBuildingFortress;